import { combineReducers } from "redux";
import { Constants } from "./contstants";
import { SportsResponse, SitesResponse, SlateResponse, App } from "./types";
import { apiReducer } from "../../utils/api/reducer";

export const selectedSport = (state = {} as SportsResponse, action: any): SportsResponse => {
  switch (action.type) {
    case Constants.SET_SPORT:
      return action.payload;
    default:
      return state;
  }
};

export const selectedSite = (state = {} as SitesResponse, action: any): SitesResponse => {
  switch (action.type) {
    case Constants.SET_SITE:
      return action.payload;
    default:
      return state;
  }
};

export const selectedType = (state = 'CLASSIC', action: any): string => {
  switch (action.type) {
    case Constants.SET_TYPE:
      return action.payload;
    default:
      return state;
  }
};

export const selectedSlate = (state = {} as SlateResponse, action: any): SlateResponse => {
  switch (action.type) {
    case Constants.SET_SLATE:
      return action.payload;
    default:
      return state;
  }
};

export const selectedApp = (state = App.DATA_HUB, action: any): App => {
  switch (action.type) {
    case Constants.SET_APP:
      return action.payload;
    default:
      return state;
  }
};

export const displayedSlate = (state = {} as SlateResponse, action: any): SlateResponse => {
  switch (action.type) {
    case Constants.SET_DISPLAYED_SLATE:
      return action.payload;
    default:
      return state;
  }
};

export const playerExposureDict = (state = {}, action: any) => {
  switch (action.type) {
    case Constants.SET_PLAYER_EXPOSURES:
      return action.payload;
    default:
      return state;
  }
};

export const stackExposureDict = (state = {}, action: any) => {
  switch (action.type) {
    case Constants.SET_STACK_EXPOSURES:
      return action.payload;
    default:
      return state;
  }
};

export const removedTeams = (state = [] as string[], action: any) => {
  switch (action.type) {
    case Constants.SET_REMOVED_TEAMS:
      return action.payload;
    default:
      return state;
  }
}

export const boostedTeams = (state = {} as {[key: string]: number}, action: any) => {
  switch (action.type) {
    case Constants.SET_BOOSTED_TEAMS:
      return action.payload;
    default:
      return state;
  }
}

export const uniqueLimit = (state =  0, action: any) => {
  switch (action.type) {
    case Constants.SET_UNIQUE_LIMIT:
      return action.payload;
    default:
      return state;
  }
}

export const commonReducer = combineReducers({
  selectedSport,
  selectedSite,
  selectedType,
  selectedSlate,
  selectedApp,
  authenticated: apiReducer(Constants.SET_AUTH),
  displayedSlate,
  playerExposureDict,
  stackExposureDict,
  removedTeams,
  boostedTeams,
  uniqueLimit,
});